import { LocaleMessages } from 'vue-i18n'

const infraPtBrLocaleMessages: LocaleMessages = {
  vm: {
    title: 'Máquina Virtual',
    pluralTitle: 'Máquinas Virtuais'
  },
  vmPayload: {
    field: {
      id: 'Id',
      node: 'Nó',
      name: 'Nome',
      status: 'Status',
      cpuUsage: 'Uso da CPU',
      memoryUsage: 'Uso da Memória',
      lastDeploy: 'Último Deploy',
      lastDeployDatetime: 'Último Deploy em',
      cronLastDatetime: 'Último Cron em',
      cronNextDatetime: 'Próximo Cron em',
      cron: 'Cron'
    },
    alert: {
      command: {
        START_DEPLOY: 'Tem certeza que deseja iniciar o deploy nesta máquina virtual?',
        START: 'Tem certeza que deseja iniciar esta máquina virtual?',
        SHUTDOWN: 'Tem certeza que deseja desligar esta máquina virtual?',
        REBOOT: 'Tem certeza que deseja reiniciar esta máquina virtual?'
      }
    },
    notification: {
      command: {
        START_DEPLOY: 'A máquina virtual iniciará o deploy em breve.',
        START: 'A máquina virtual iniciará em breve.',
        SHUTDOWN: 'A máquina virtual desligará em breve.',
        REBOOT: 'A máquina virtual reiniciará em breve.'
      }
    },
    value: {
      status: {
        STOPPED: 'Desligado',
        RUNNING: 'Executando'
      },
      lastDeploy: {
        STARTED: 'Iniciado',
        COMPLETED: 'Concluído',
        CANCELED: 'Cancelado',
        FAILED: 'Falhou'
      },
      command: {
        START_DEPLOY: 'Iniciar o Deploy',
        START: 'Iniciar',
        SHUTDOWN: 'Desligar',
        REBOOT: 'Reiniciar'
      }
    }
  }
}

export default infraPtBrLocaleMessages